export const API_GET_VOUCHER_CANCEL = "/comprobantes/anulados/";

export const API_GET_SEARCH_CANCEL= `/comprobantes/anulados/busqueda/`;